import { useRef, useState } from 'react';

import Form from 'app/components/Form';

const UploadForm = props => {
  const {
    onClose,
    action,
    onSubmit,
    multiple
  } = props;

  let field = { name: 'files', type: 'file' };
  if (multiple) {
    field.label = 'Select Files';
    field.multiple = true;
  } else {
    // a FileList will be submitted, even if multiple files aren't enabled.
    // keeping the field name as "files" to avoid confusion
    field.label = 'Select File';
  }

  let fields = [field];

  return (
    <Form {...{
      fields,
      action,
      onClose,
      onSubmit
    }} />
  );
}

export default UploadForm;
